import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { Link, withRouter } from "react-router-dom";
import { extendObservable } from 'mobx';


@inject('core')
@observer
class PriceList extends React.Component {
	
	constructor(props) {
		super(props)
		this.changeNeeds = this.changeNeeds.bind(this)
		this.highlightPrice = this.highlightPrice.bind(this)
		this.state = {
			highlight: false
		}
	}		
	
	componentDidMount() {
		const { core } = this.props
	}
	
	changeNeeds(product_id, change_delta) {
		const { core } = this.props

		//core.action({ op: 'setNeeds', product_id: product_id, needs: core.products.find( p => p.product_id == product_id ).needs + change_delta })
	}
	
	highlightPrice(product_id) {
		this.setState({highlight: product_id})
	}
	
	changePrice(product_id, store_id) {
		const { core } = this.props
		const product  = core.products.find(p => p.product_id == product_id)
		const preset   = product.prices[store_id] ? product.prices[store_id].toFixed(2) : ''
		var price = window.prompt('Price @ ' + core.stores.find(s => s.store_id == store_id).name, preset)
		if ((typeof price !== 'undefined') && (price !== 'null') && (price !== null)) {
			const uuid = core.uuid('p')
			core.action({ 
				op: 'setPrice', 
				product_id: product_id, 
				store_id: store_id, 
				price: price.replace(/[^0-9\,\.]/g, '').replace(',', '.')
			})			
		}
	}

	render() {
		const { core, product_id, store_id } = this.props
		const { highlight }                  = this.state
		
		const products = product_id ? core.products.filter(p => p.product_id == product_id) : core.products
		const stores   = store_id   ? core.stores.filter(p => p.store_id     == store_id)   : core.stores

		//console.log(stores.splice().sort((a, b) => a.name.localeCompare(b.name)))
		console.log('hovering', highlight)

		const PriceList = products.map((product) => {
			const p = stores.map( (store) => {
					return {
						name: store.name, 
						html: <tr key={store.store_id}>
							<td className="price clickable" onClick={() => { this.changePrice(product.product_id, store.store_id)}}>
									{ product.prices[store.store_id] ? product.prices[store.store_id].toFixed(2) : '-.--' }
							</td>
							<td className="store-name clickable" onClick={() => { this.props.history.push('/' + core.pod_id + '/store/' + store.store_id) }}>
									{ store.name }
							</td>
						</tr>
					}
				}).sort((a, b) => a.name.localeCompare(b.name)).map(o => o.html)
				
			return p
			
		})
		
		return <table id="price-list"><tbody>
		{PriceList}
		</tbody></table>
	}
	
}

export default withRouter(PriceList)

